import React from "react";
import BackButton from "../../Components/BackButton/BackButton.module";
import NewConnectionProfile from "../../Components/NewConnectionProfile/NewConnectionProfile.module";

const NewProfile = ({ loadingShow, setLoadingShow }) => {
  return (
    <>
      <BackButton />
      <NewConnectionProfile
        loadingShow={loadingShow}
        setLoadingShow={setLoadingShow}
      />
    </>
  );
};

export default NewProfile;
